import React, {
  useState,
  useContext,
} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import {
  Grid,
  Typography,
  IconButton,
  Button,
  TextField,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { PageContext } from '../../../contexts';

import useStyles from './styles';

const SaveFields = (props) => {
  const { t } = useTranslation();
  const {
    data,
    onCancel,
    onSubmit,
  } = props;

  const pageContext = useContext(PageContext);
  const {
    savedFields,
  } = pageContext.state;

  const classes = useStyles(props);

  const [name, setName] = useState(data);
  const [errors, setErrors] = useState({});

  const debounceCallBack = _.debounce((callBack) => {
    callBack();
  }, 200);

  const handleChange = (e) => {
    const { value } = e.target;
    // Don't allow duplicate filter name
    debounceCallBack(() => {
      if (savedFields.length > 0) {
        const isExists = savedFields.filter((filter) => filter.name === value).length > 0;
        if (isExists) {
          setErrors({
            name: t('component.label.save_view_exist', 'Filter name already exists'),
          });
        } else {
          setErrors({});
        }
      }
      setName(value);
    });
  };

  const handleCancel = (e) => {
    onCancel(e);
  };

  const handleSubmit = () => {
    onSubmit(name);
  };

  return (
    <div className={classes.root}>
      <Grid
        className={classes.modalTopBar}
        container
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography className={classes.modalTitle}>{t('component.label.save_view_title', 'Save view')}</Typography>
        <IconButton className={classes.iconClose} onClick={handleCancel}>
          <CloseIcon />
        </IconButton>
      </Grid>
      <div>
        <TextField
          fullWidth
          variant="outlined"
          name="name"
          inputProps={{ maxLength: 25 }}
          defaultValue={data}
          error={!!errors.name}
          helperText={errors.name}
          onChange={handleChange}
        />
      </div>
      <div className={classes.controls}>
        <Button variant="outlined" onClick={handleCancel}>
          {t('component.label.cancel', 'Cancel')}
        </Button>
        <Button variant="contained" disabled={!name || !!errors.name} onClick={handleSubmit}>
          {t('component.label.save', 'Save')}
        </Button>
      </div>
    </div>
  );
};

SaveFields.propTypes = {
  data: PropTypes.string,
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
};

SaveFields.defaultProps = {
  data: '',
  onCancel: () => {},
  onSubmit: () => {},
};

export default SaveFields;
